module.exports = {"id":"137361","name":"Giampaolo Pazzini","rating":"76","photo":"./data/images/photos/2/137361.png","club":{"name":"Levante UD","logo":"./data/images/clubs/LevanteUD.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GiampaoloPazzini0.json
// module id = 1581
// module chunks = 0